<template>
  <div class="home">
    <div class="banner">
      <div class="container">
        <div class="title">{{ $t('home.title') }}</div>
        
        <div class="desc">{{ $t('home.desc') }}</div>
        <!-- <div class="btn" @click="goToVideo">{{ $t('home.videoTitle') }} <img src="@/assets/icons/play.svg" alt=""></div> -->
        <div class="btn" @click="goToVideo">{{ $t('home.videoTitleOpenDots2') }} <img src="@/assets/icons/play.svg" alt=""></div>
      </div>
      <img  class="banner-bg pc-show" src="@/assets/images/home_banner_pc.webp" alt="">
      <img  class="banner-bg mb-show" src="@/assets/images/home_banner_mb.webp" alt="">
    </div>
    <div class="container">
      <div class="section-1">
        <div class="tilte">{{ $t('home.productListTitle') }} <div class="new-tag"><span>{{ $t('home.newTag') }}</span></div></div>
        <div class="desc">{{ $t('home.productListDesc') }}</div>
        <ul>
          <li v-for="(item,index) in productList.filter((li) => li.id !== '6')" :key="item.title" @click="goToProductDetail(item.id,'3.5')">
            <img :src="getProductPic(index,'3.5')" alt="">
            <div class="product-info">
              <div class="prdouct-title" :class="{'prdouct-title-en': lang === 'en'}"><span>POP3.5</span> <i v-if="lang === 'zh'"></i> {{ item.title}}</div>
              <div class="prdouct-tags">
                <span  v-for="tag in item.tags" :key="tag">{{ tag }}</span>
              </div>
            </div>  
          </li>
        </ul>
      </div>
      <div class="section-2">
        <div class="tilte">{{ $t('home.productListTitle2') }} <div class="classic-tag"><span>{{ $t('home.classicTag') }}</span></div></div>
        <div class="desc"> {{ $t('home.classicDesc') }}</div>
        <ul>
          <li v-for="(item,index) in productList" :key="item.titlec" @click="goToProductDetail(item.id,'3.0')">
            <img :src="getProductPic(index,'3.0')" alt="">
            <div class="product-info">
              <div class="prdouct-title" :class="{'prdouct-title-en': lang === 'en'}"><span>POP3.0</span> <i v-if="lang === 'zh'"></i> {{ item.title }}</div>
              <div class="prdouct-desc">{{ item.desc }}</div>
            </div>  
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>4
import { productListCn, productListEn } from '@/utils/util.js'
export default {
  computed: {
    productList() {
      // 简化并兼容本地化的产品列表选择
      return this.lang === 'zh' ? productListCn : productListEn;
    },
    lang() {
      // 缓存当前语言，减少多次访问
      return this.$i18n.locale;
    }
  },
  methods: {
    goToVideo() {
      // const productVideoInfo = { productId: '1', productType: '3.5' ,'type':'replace'};
      // localStorage.setItem('productVideoInfo', JSON.stringify(productVideoInfo));
      // this.$router.push({
      //   path: '/course',
      //   params: productVideoInfo
      // });
       const productVideoInfo = { productId: '1', productType: '3.5' ,'type':'replace'};
      localStorage.setItem('productVideoInfo', JSON.stringify(productVideoInfo));
      this.$router.push({
        path: '/opendots2TFcard',
        params: productVideoInfo
      });
    },
    getProductPic(index, type) {
      return require(`@/assets/images/procuct/home_pic_${type}_${index + 1}.webp`);
    },
    goToProductDetail(id, type) {
      // 优化：只调用一次localStorage和push
      const productInfo = { productId: id, productType: type };
      localStorage.setItem('productInfo', JSON.stringify(productInfo));
      this.$router.push({
        path: '/product',
        params: productInfo
      });
    }
  }
}
</script>

<style lang='scss' scoped>
.home {
  .banner {
    padding-top: 107px;
    margin-bottom: 96px;
    position: relative;
    .title {
      font-size: 42px;
      font-weight: 500;
      line-height: 53px;
      margin-bottom: 16px;
    }
    .desc {
      font-size: 24px;
      line-height: 24px;
      margin-bottom: 32px;
    }
    .btn {
      cursor: pointer;
      display: inline-block;
      padding: 14px 20px;
      background: #000;
      color: #fff;
      font-size: 16px;
      font-weight: 500;
      line-height: 21px;
      border-radius: 4px;
      margin-bottom: 40px;
      img {
        display: inline-block;
        width: 17.5px;
        margin-left: 8px;
        position: relative;
        top: 2px;
      }
    }
    .banner-bg {
      position: absolute;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 100%;
      object-fit: cover;
      z-index: -1;
    }
  }
  .section-1, .section-2 {
    margin-bottom: 96px;
    .tilte {
      font-size: 36px;
      font-weight: 500;
      line-height: 110%;
      margin-bottom: 16px;
      display: flex;
      align-items: center;
      gap: 16px;
      .new-tag {
        font-size: 16px;
        line-height: 21px;
        padding: 8px 12px;
        border-radius: 6px;
        background: linear-gradient(90deg, rgba(255, 238, 229, 0.60) 0.03%, rgba(255, 255, 255, 0.60) 188.15%);
        backdrop-filter: blur(10px);
        span{
          background: linear-gradient(285deg, #A94D22 9.79%, #FF6F2D 36.76%, #772500 85.37%);
          background-clip: text;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
      }
      .classic-tag {
        font-size: 16px;
        line-height: 21px;
        padding: 8px 12px;
        border-radius: 6px;
        background: linear-gradient(90deg, #F3F4F6 0.23%, #FFF 158.59%);
        backdrop-filter: blur(10px);
        span{
          background: linear-gradient(99deg, #595959 14.3%, #A7A7A7 59.35%, #737373 89.09%);
          background-clip: text;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
      }
    }
    .desc {
      font-size: 18px;
      line-height: 22px;
      margin-bottom: 16px;
      color: #737373;
    }
    ul {
      padding-top: 40px;
      border-top: 1px solid #D4D4D4;
      display: flex;
      flex-wrap: wrap;
      align-items: stretch;
      gap: 24px;
      li {
        flex: 0 0 calc(33.333% - 16px);
        cursor: pointer;
        margin-bottom: 32px;
        display: flex;
        flex-direction: column;
        border-radius: 6px;
        overflow: hidden;
        img {
          width: 100%;
        }
        .product-info {
         background: #F3F4F6;
         padding: 16px;
         flex: 1;
         display: flex;
         flex-direction: column;
          .prdouct-title {
            font-size: 24px;
            font-weight: 500;
            line-height: 29px;
            margin-bottom: 12px;
            color: #0A0A0A;
            display: flex;
            align-items: center;
            span {
              font-size: 16px;
              line-height: 21px;
              color: #0A0A0A;
              border: 1px solid #000;
              border-radius: 2px;
              padding: 4px 8px;
            }
            i {
              display: inline-block;
              width: 1px;
              height: 18px;
              background: #000;
              margin: 0px 8px;
            }
          }
          .prdouct-title-en {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            gap: 4px;
          }
          .prdouct-tags {
            width: 100%;
            display: flex;
            align-items: center;
            gap: 8px;
            span {
              font-size: 14px;
              line-height: 19px;
              color: #737373;
              border: 1px solid #D1D5DB;
              border-radius: 6px;
              padding: 4px 8px;
            }
          }
          .prdouct-desc {
            font-size: 14px;
            line-height: 130%;
            color: #737373;
            display: flex;
            flex-direction: column;
            justify-content: center;
            flex: 1;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 850px) {
  .home  {
    .banner {
      margin-bottom: 64px;
      padding-top: 102px;
      .title {
      font-size: 32px;
      line-height: 36px;
      margin-bottom: 12px;
    }
    .desc {
      font-size: 18px;
      line-height: 120%;
      margin-bottom: 24px;
    }
    .btn {
      padding: 9.5px 20px;
      margin-bottom: 42px;
      img {
        width: 17.5px;
        margin-left: 8px;
      }
    }
    }
    .section-1,.section-2 {
      margin-bottom: 64px;
    .tilte {
      font-size: 24px;
      line-height: 29px;
    }
    .desc {
      font-size: 16px;
      line-height: 120%;
    }
    ul {
      padding-top: 24px;
      gap: 16px;
      li {
        flex: 0 0 calc(50% - 8px);
        margin-bottom: 16px;
        .product-info {
          .prdouct-title {
            font-size: 18px;
            line-height: 22px;
            flex-direction: column;
            align-items: flex-start;
            gap: 6px;
            span {
              font-size: 16px;
              line-height: 21px;
              color: #0A0A0A;
              border: 1px solid #000;
              border-radius: 2px;
              padding: 4px 8px;
            }
            i {
              display: none;
            }
          }
          .prdouct-tags {
            gap: 6px;
          }
        }
      }
    }
    }
  }
 
}
</style>